import { AREAS } from "../lib/site";

const scrollTo = (id) => {
  const t = document.getElementById(id);
  if (!t) return;
  if (window.__lenis) window.__lenis.scrollTo(t, { offset: -80 });
  else t.scrollIntoView({ behavior: "smooth" });
};

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="bg-[#FAF7F2] border-t border-[#1C1917]/10 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-14">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <p className="font-display text-4xl text-[#1C1917]">Jessica Bacon<span className="text-[#2D4A3E]">.</span></p>
            <p className="mt-4 font-display italic text-xl text-[#57534E] max-w-sm">
              Because it's all about you.
            </p>
            <button
              data-testid="footer-book-btn"
              onClick={() => scrollTo("booking")}
              className="btn-lux mt-8 inline-flex rounded-full bg-[#18181B] text-[#FAF7F2] px-7 py-3.5 label hover:bg-[#2D4A3E]"
            >
              Book a Session
            </button>
          </div>

          <div className="md:col-span-3">
            <p className="label text-[#2D4A3E] mb-5">Coverage</p>
            <ul className="space-y-2.5">
              {AREAS.map((a) => (
                <li key={a} className="text-[#57534E] text-sm" data-testid={`footer-area-${a.replace(/\s+/g, "-").toLowerCase()}`}>{a}</li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="label text-[#2D4A3E] mb-5">Get in touch</p>
            <a href="mailto:jmbacon926@gmail.com" data-testid="footer-email" className="block text-[#1C1917] text-lg font-display hover:text-[#2D4A3E] transition-colors">
              jmbacon926@gmail.com
            </a>
            <p className="mt-3 text-[#57534E] text-sm">Private at-home Pilates<br />Hampstead, London NW3</p>
            <div className="mt-6 flex gap-4">
              <a href="#top" onClick={(e) => { e.preventDefault(); scrollTo("top"); }} data-testid="footer-instagram" className="label text-[#57534E] hover:text-[#2D4A3E]">Instagram</a>
              <a href="#top" onClick={(e) => { e.preventDefault(); scrollTo("top"); }} data-testid="footer-back-top" className="label text-[#57534E] hover:text-[#2D4A3E]">Back to top ↑</a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-[#1C1917]/10 flex flex-col sm:flex-row justify-between gap-3">
          <p className="font-mono-pp text-xs text-[#78716C]">© 2026 Jessica Bacon. All rights reserved.</p>
          <p className="font-mono-pp text-xs text-[#78716C]">Private at-home Pilates · Hampstead &amp; North London</p>
        </div>
      </div>
    </footer>
  );
}
